import connect from 'react-redux/es/connect/connect';

import GuestHeader from '../components/GuestHeader';
import { createGuest, loginAsCustomerWithId } from '../actions/user';

const mapStateToProps = state => ({
    user: state.user.user,
    cartItemCount: state.cart.cartItems.length,
    customer: state.user.customer,
    modal: state.user.modal
});

const mapDispatchToProps = dispatch => ({
    loginAsCustomerWithId: (customerId, showModal, onError, onSuccess) => {
        dispatch(loginAsCustomerWithId(customerId, showModal, onError, onSuccess));
    },
    createGuest: (
        firstname,
        lastname,
        phone,
        email,
        additional_emails,
        guest_field_info,
        arrival_date,
        departure_date,
        internal_notes,
        notification,
        source_id,
        onSuccess,
        onError
    ) => {
        dispatch(
            createGuest({
                firstname,
                lastname,
                phone,
                email,
                additional_emails,
                guest_field_info,
                arrival_date,
                departure_date,
                internal_notes,
                notification,
                source_id,
                onSuccess,
                onError
            })
        );
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GuestHeader);
